// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"V9-z"};